"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetBaseToJSON = exports.AdSetBaseFromJSONTyped = exports.AdSetBaseFromJSON = exports.instanceOfAdSetBase = void 0;
var runtime_1 = require("../runtime");
var Delivery_1 = require("./Delivery");
var FrequencyCap_1 = require("./FrequencyCap");
var VideoDeliveryFormat_1 = require("./VideoDeliveryFormat");
/**
 * Check if a given object implements the AdSetBase interface.
 */
function instanceOfAdSetBase(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdSetBase = instanceOfAdSetBase;
function AdSetBaseFromJSON(json) {
    return AdSetBaseFromJSONTyped(json, false);
}
exports.AdSetBaseFromJSON = AdSetBaseFromJSON;
function AdSetBaseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'startTime': !(0, runtime_1.exists)(json, 'start_time') ? undefined : (new Date(json['start_time'])),
        'endTime': !(0, runtime_1.exists)(json, 'end_time') ? undefined : (new Date(json['end_time'])),
        'frequencyCaps': !(0, runtime_1.exists)(json, 'frequency_caps') ? undefined : (new Set(json['frequency_caps'].map(FrequencyCap_1.FrequencyCapFromJSON))),
        'bidMicroAmount': !(0, runtime_1.exists)(json, 'bid_micro_amount') ? undefined : json['bid_micro_amount'],
        'delivery': !(0, runtime_1.exists)(json, 'delivery') ? undefined : (0, Delivery_1.DeliveryFromJSON)(json['delivery']),
        'datasetId': !(0, runtime_1.exists)(json, 'dataset_id') ? undefined : json['dataset_id'],
        'spanFreezeAt': !(0, runtime_1.exists)(json, 'span_freeze_at') ? undefined : (new Date(json['span_freeze_at'])),
        'iasCampaignId': !(0, runtime_1.exists)(json, 'ias_campaign_id') ? undefined : json['ias_campaign_id'],
        'videoDeliveryFormats': !(0, runtime_1.exists)(json, 'video_delivery_formats') ? undefined : (new Set(json['video_delivery_formats'].map(VideoDeliveryFormat_1.VideoDeliveryFormatFromJSON))),
    };
}
exports.AdSetBaseFromJSONTyped = AdSetBaseFromJSONTyped;
function AdSetBaseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'start_time': value.startTime === undefined ? undefined : (value.startTime.toISOString()),
        'end_time': value.endTime === undefined ? undefined : (value.endTime.toISOString()),
        'frequency_caps': value.frequencyCaps === undefined ? undefined : (Array.from(value.frequencyCaps).map(FrequencyCap_1.FrequencyCapToJSON)),
        'bid_micro_amount': value.bidMicroAmount,
        'delivery': (0, Delivery_1.DeliveryToJSON)(value.delivery),
        'dataset_id': value.datasetId,
        'span_freeze_at': value.spanFreezeAt === undefined ? undefined : (value.spanFreezeAt.toISOString()),
        'ias_campaign_id': value.iasCampaignId,
        'video_delivery_formats': value.videoDeliveryFormats === undefined ? undefined : (Array.from(value.videoDeliveryFormats).map(VideoDeliveryFormat_1.VideoDeliveryFormatToJSON)),
    };
}
exports.AdSetBaseToJSON = AdSetBaseToJSON;
